import { baseApi } from "@/services/base-api";

export const removeAccessToken = () => {
  localStorage.removeItem("accessToken");
  sessionStorage.removeItem("accessToken");
  baseApi.defaults.headers.common["Authorization"] = undefined;
};
